exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sub-app-container {\n  flex-direction: row;\n  position: relative;\n  overflow: auto;\n  background: #fff;\n  padding: 24px;\n  border-radius: 4px;\n}\n.sub-app-container.no-padding {\n  padding: 0;\n}\n.sub-app-container.no-background {\n  background: none;\n}\n.sub-app-container {\n  min-height: calc(100vh - 200px);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/AntD/assets/stylus/micro-app.styl
// module id = 4868
// module chunks = 0